/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import { LayoutGridAdd } from 'tabler-icons-react';
import { useMatch, useNavigate } from 'react-router';
import { useMantineColorScheme } from '@mantine/core';
import Header1 from './Header1';
import styles from './Layout1.module.css';
import { buttonize } from '../../utilities/general';
import routes from '../../router/routes';
// import { buttonize } from '../../utilities/general';

const Layout1 = ({ children }) => {
  const { colorScheme } = useMantineColorScheme();
  // const [tabName, changeTab] = useState('positions');
  const matchTraderListing = !!useMatch(routes.TRADERS_DATA_LISTING);
  const matchTraderDetails = !!useMatch(routes.TRADERS_DATA_DETAIL);
  // const matchBalanceSheet = !!useMatch(routes.BALANCE_SHEET);
  // const matchCompanyData = !!useMatch(routes.COMPANY_DATA);
  const matchCompanyDataV2 = !!useMatch(routes.COMPANY_DATA_V2);
  const matchColdWallet = !!useMatch(routes.COLD_WALLET);
  const matchLivePositions = !!useMatch(routes.LIVE_POSITIONS);
  // const matchFormData = !!useMatch(routes.FORM);
  // const matchSettings = !!useMatch(routes.SETTINGS);

  // const sidebarItems = [{
  //   Icon: LayoutGridAdd,
  //   label: 'Trader Data',
  //   route: routes.TRADERS_DATA_LISTING,
  //   isActive: matchTraderListing || matchTraderDetails,
  //   barColor: '#F9A61A',
  // },
  // // {
  // //   Icon: LayoutGridAdd,
  // //   label: 'Company Data',
  // //   route: routes.COMPANY_DATA,
  // //   isActive: matchCompanyData,
  // //   barColor: '#F9A61A',
  // // },
  // {
  //   Icon: LayoutGridAdd,
  //   label: 'Company Data',
  //   route: routes.COMPANY_DATA_V2,
  //   isActive: matchCompanyDataV2,
  //   barColor: '#F9A61A',
  // },
  // {
  //   Icon: LayoutGridAdd,
  //   label: 'Cold Wallet',
  //   route: routes.COLD_WALLET,
  //   isActive: matchColdWallet,
  //   barColor: '#F9A61A',
  // },
  // {
  //   Icon: LayoutGridAdd,
  //   label: 'Live Positions',
  //   route: routes.LIVE_POSITIONS,
  //   isActive: matchLivePositions,
  //   barColor: '#F9A61A',
  // },
  //   // {
  //   //   Icon: LayoutGridAdd,
  //   //   label: 'Liabilities & Assets',
  //   //   route: routes.FORM,
  //   //   isActive: matchFormData,
  //   //   barColor: '#F9A61A',
  //   // },
  //   // {
  //   //   Icon: LayoutGridAdd,
  //   //   label: 'Settings',
  //   //   route: routes.SETTINGS,
  //   //   isActive: matchSettings,
  //   //   barColor: '#F9A61A',
  //   // },
  //   // , {
  //   //   Icon: Table,
  //   //   label: 'Balance Sheet',
  //   //   route: routes.BALANCE_SHEET,
  //   //   isActive: matchBalanceSheet,
  //   //   barColor: '#F9A61A',
  //   // }
  // ];

  // const tabBarOptions = [
  //   {
  //     label: 'Overview',
  //     value: 'overview',
  //   },
  //   {
  //     label: 'Positions',
  //     value: 'positions',
  //   },
  //   {
  //     label: 'Closed Positions',
  //     value: 'closedPositions',
  //   },
  //   {
  //     label: 'Wallet',
  //     value: 'wallet',
  //   },
  //   {
  //     label: 'Orders',
  //     value: 'orders',
  //   },
  //   {
  //     label: 'Transfers',
  //     value: 'transfers',
  //   },
  // ];

  // const firstActiveRoute = sidebarItems.find((item) => item.isActive);

  // const navigate = useNavigate();

  return (
    <div
      className={`h-screen w-screen flex flex-col ${styles.mainContainer} ${colorScheme === 'dark' && styles.darkBody}`}
    >
      <Header1 />
      <div className="flex-1 overflow-hidden">
        <div className={`h-full ${styles.mainBody}`}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout1;
